import React from "react";
import { Box } from "@mui/material";
import PathLabTest from "./PathLabTest.jsx";
const PathLab = ({ appointment, patient = null }) => {
  return (
    <Box>
      <PathLabTest appointment={appointment} patient={patient} />
    </Box>
  );
};

export default PathLab;
